import V3Check from './V3Check'
import { CheckUtils } from 'utils'
import { HelpEmail, MiniNotice, HelpLink } from 'components'
import { Link } from 'react-router'
import { Button } from 'components'
import { Enum } from 'utils'

export default class V3TitleCheck extends React.Component {
  static contextTypes = {
    currentUser: React.PropTypes.object.isRequired
  }

  constructor(props) {
    super(props)

    this.renderInfo = this.renderInfo.bind(this)
    this.renderDetails = this.renderDetails.bind(this)
  }

  render() {
    const props = {
      ...this.props,
      info: this.renderInfo,
      details: this.renderDetails
    }

    return <V3Check {...props} />
  }

  renderDetails() {
    return CheckUtils.renderDetailsList(this.props.check.checkItems)
  }

  goToPageTypeTemplate() {
    const pageType = localStorage
      .getItem('pageType')
      .replace('page_type.', '')
      .replace(':', '')

    switch (pageType) {
      case 'homepage':
        window.location = Enum.pageTemplates.index
        break
      case 'catalog':
        window.location = Enum.pageTemplates.catalog
        break
      case 'collection':
        window.location = Enum.pageTemplates.collection
        break
      case 'product':
        window.location = Enum.pageTemplates.product
        break
      case 'blogHome':
        window.location = Enum.pageTemplates.blogHome
        break
      case 'blogPost':
        window.location = Enum.pageTemplates.blogPost
        break
      case 'page':
        window.location = Enum.pageTemplates.page
        break
      default:
        window.location = Enum.pageTemplates.other
    }
  }

  renderInfo() {
    let metaTitleHtml
    const pageType = localStorage
      .getItem('pageType')
      .replace(':', '')
      .replace('page_type.', '')

    if (this.context.currentUser.appPlan === 'free') {
      switch (pageType) {
        case 'homepage':
          metaTitleHtml = this.renderHomepageInstructions()
          break
        case 'collection':
          metaTitleHtml = this.renderCollectionInstructions()
          break
        case 'catalog':
          metaTitleHtml = this.renderCatalogInstructions()
          break
        case 'page':
          metaTitleHtml = this.renderPageInstructions()
          break
        case 'product':
          metaTitleHtml = this.renderProductInstructions()
          break
        case 'blogHome':
          metaTitleHtml = this.renderBlogHomeInstructions()
          break
        case 'blogPost':
          metaTitleHtml = this.renderBlogPostInstructions()
          break
        default:
          metaTitleHtml = this.renderOtherInstructions()
          break
      }
    } else {
      metaTitleHtml = (
        <div>
          <h3>Add or edit a page title</h3>
          <p>
            Once Plug in SEO Plus is fully installed in your theme, the app generates page titles automatically from the page content.
          </p>

          <p>
            You can edit your page titles with Plug in SEO's page title templating tool.
          </p>

          <ol>
            <li>Go to your <Link to="/plus/title-description" target="_blank">Page Title and Meta Descriptions</Link> settings</li>
            <li>Select the relevant page type</li>
            <li>Edit the title template</li>
          </ol>

          <h3>Remove multiple page titles</h3>
          <p>
            If you have multiple page titles or are missing a page title, you can email us at <HelpEmail /> and we'll help you resolve this problem.
          </p>
        </div>
      )
    }
    return (
      <div>
        <div>
          <h2>Key points</h2>
          <p>
            This is the HTML &lt;title&gt; tag located inside the &lt;head&gt;
            of each page on your site.
          </p>
          <hr />
          <h2>How it's used</h2>
          <ul>
            <li>Used in search engine algorithms</li>
            <li>
              The page title is shown bold and as the link in search results
            </li>
            <li>
              Displayed in the visitor's title bar, their bookmarks and if they
              share a link
            </li>
          </ul>
          <hr />
          <h2>Best practice</h2>
          <ul>
            <li>Every page should have a single unique title</li>
            <li>Each title should start with a unique phrase</li>
            <li>Use your most important keywords first</li>
            <li>A sentence or less, naturally including your keywords</li>
            <li>
              Not a long list of keywords, it will be likely ignored as spammy
            </li>
            <li>
              Something like this is good: Men's red parka winter jacket | Ben's
              Jacket Shop
            </li>
          </ul>
          <hr />
        </div>
        <div>
          <h2>Fix this yourself</h2>
          {metaTitleHtml}
        </div>
      </div>
    )
  }

  fixItHtml() {
    return `
    <!-- If there are two or more <title>, delete all but one and change it as below -->
    <!-- Or if there are none or one, add/change it to this --> \
    <head>
    <title>{{ page_title }} | {{ shop.name }}  {% if template == '404' %}404 Error{% endif %}</title>
    ...
    </head>
    <!-- Don't include the head tags, the comments or the dots (...) -->`
  }

  renderTroubleshooting() {
    return (
      <div>
        <h3>Troubleshooting</h3>
        <ul className="icon-font-list details__content__troubleshooting-list">
          <HelpLink
            url="https://support.pluginuseful.com/hc/en-us/articles/23534740981908-Why-does-my-SEO-check-say-that-I-have-multiple-page-titles-but-I-can-only-find-one-in-the-code"
            title="My SEO check says that I have multiple page titles but I can only find one in the code"
          />
          <HelpLink
            url="https://support.pluginuseful.com/hc/en-us/articles/23534773881364-Why-is-my-SEO-check-still-failing-after-I-added-a-page-title-in-my-Shopify-settings"
            title="I added a page title in my Shopify settings and my SEO check still fails"
          />
        </ul>
      </div>
    )
  }

  renderRemoveMultiplePageTitles() {
    const currentUser = this.context.currentUser
    const storeThemesURL = 'https://' + currentUser.shop + '/admin/themes'
    const htmlGuideLink =
      'https://support.pluginuseful.com/hc/en-us/articles/23534791516308-A-Guide-to-HTML-Code-Basics'

    return (
      <div>
        <h3>Remove multiple page titles</h3>
        <MiniNotice 
          alert 
          header="Coding required"
          note={
            <span>
              New to coding?{' '}
              <a href={htmlGuideLink} target="_blank">Read our guide of HTML code basics</a>
            </span>
          }
        />

        <p>To remove excess page titles you will have to manually edit your theme code.</p>
        <ol>
          <li>
            <a target="_blank" href={storeThemesURL}>
              View your themes
            </a>{' '}
            in Shopify
          </li>
          <li>Select ‘Actions’ and ‘Edit code’ for your live theme</li>
          <li>Open the theme.liquid file</li>
          <li>
            Type Control+F (Command+F on a Mac) to open the file search box
          </li>
          <li>
            Search for <code>&lt;/title&gt;</code> in the file to find the different titles in your theme
          </li>
          <li>Decide which title that you’d like to remove</li>
          <li>
            Add an opening comment tag <code>&#123;% comment %&#125;</code> before the start of the <code>&lt;title&gt;</code> tag
          </li>
          <li>
            Add a closing comment tag <code>&#123;% endcomment %&#125;</code> after the <code>&lt;/title&gt;</code> tag{' '}
          </li>
        </ol>
      </div>
    )
  }

  renderHomepageInstructions() {
    const currentUser = this.context.currentUser
    const themesPreferencesURL = 'https://' + currentUser.shop + '/admin/online_store/preferences'

    return (
      <div>
        <h3>Add or edit your homepage title</h3>

        <ol>
          <li>Go to your <a href={themesPreferencesURL} target="_blank">online store > preferences</a> in Shopify</li>
          <li>Add or edit your title in the ‘Homepage title’ field</li>
        </ol>

        {this.renderRemoveMultiplePageTitles()}
        
        {this.renderTroubleshooting()}
      </div>
    )
  }

  renderCollectionInstructions() {
    const currentUser = this.context.currentUser
    const collectionsURL = 'https://' + currentUser.shop + '/admin/collections'

    return (
      <div>
        <h3>Add or edit a collection page title</h3>

        <ol>
          <li>Go to your <a href={collectionsURL} target="_blank">products > collections</a> in your Shopify admin</li>
          <li>Select the collection missing the title</li>
          <li>Locate the ‘Search engine listing preview’ at the bottom of the collection page</li>
          <li>Click ‘Edit website SEO’</li>
          <li>Add or edit your title in the ‘Page title’ field</li>
        </ol>

        {this.renderRemoveMultiplePageTitles()}

        {this.renderTroubleshooting()}
      </div>
    )
  }

  renderCatalogInstructions() {
    return (
      <div>
        {this.renderRemoveMultiplePageTitles()}

        {this.renderTroubleshooting()}
      </div>
    )
  }

  renderPageInstructions() {
    const currentUser = this.context.currentUser
    const pagesURL = 'https://' + currentUser.shop + '/admin/pages'

    return (
      <div>
        <h3>Add or edit a page title</h3>

        <ol>
          <li>Go to your <a href={pagesURL} target="_blank">online store > pages</a> in your Shopify admin</li>
          <li>Select the page missing the title</li>
          <li>Locate the ‘Search engine listing preview’ at the bottom of the page</li>
          <li>Click ‘Edit website SEO’</li>
          <li>Add or edit your title in the ‘Page title’ field</li>
        </ol>

        {this.renderRemoveMultiplePageTitles()}

        {this.renderTroubleshooting()}
      </div>
    )
  }

  renderProductInstructions() {
    const currentUser = this.context.currentUser
    const productsURL = 'https://' + currentUser.shop + '/admin/products'

    return (
      <div>
        <h3>Add or edit a product page title</h3>

        <ol>
          <li>Go to your <a href={productsURL} target="_blank">products</a> in your Shopify admin</li>
          <li>Select the product missing the title</li>
          <li>Locate the ‘Search engine listing preview’ at the bottom of the product page</li>
          <li>Click ‘Edit website SEO’</li>
          <li>Add or edit your title in the ‘Page title’ field</li>
        </ol>

        {this.renderRemoveMultiplePageTitles()}

        {this.renderTroubleshooting()}
      </div>
    )
  }

  renderBlogHomeInstructions() {
    const currentUser = this.context.currentUser
    const blogHomeURL = 'https://' + currentUser.shop + '/admin/blogs'

    return (
      <div>
        <h3>Add or edit your blog page title</h3>

        <ol>
          <li>Go to your <a href={blogHomeURL} target="_blank">online store > blog posts > manage blogs</a>{' '} in your Shopify admin</li>
          <li>Select the relevant blog</li>
          <li>Locate the ‘Search engine listing preview’ at the bottom of the page</li>
          <li>Click ‘Edit website SEO’</li>
          <li>Add or edit your title in the ‘Page title’ field</li>
        </ol>

        {this.renderRemoveMultiplePageTitles()}

        {this.renderTroubleshooting()}
      </div>
    )
  }

  renderBlogPostInstructions() {
    const currentUser = this.context.currentUser
    const blogPostsURL = 'https://' + currentUser.shop + '/admin/articles'

    return (
      <div>
        <h3>Add or edit your blog post title</h3>

        <ol>
          <li>Go to your <a href={blogPostsURL} target="_blank">online store > blog posts</a> in your Shopify admin</li>
          <li>Select the blog post missing the title</li>
          <li>Locate the ‘Search engine listing preview’ at the bottom of the page</li>
          <li>Click ‘Edit website SEO’</li>
          <li>Add or edit your title in the ‘Page title’ field</li>
        </ol>

        {this.renderRemoveMultiplePageTitles()}

        {this.renderTroubleshooting()}
      </div>
    )
  }

  renderOtherInstructions() {
    return (
      <div>
        {this.renderRemoveMultiplePageTitles()}

        {this.renderTroubleshooting()}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/components/v3_checks/V3TitleCheck.js